import { render, staticRenderFns } from "./ModelsActions.vue?vue&type=template&id=3079ea76&scoped=true"
import script from "./ModelsActions.vue?vue&type=script&lang=js"
export * from "./ModelsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079ea76",
  null
  
)

export default component.exports